import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../reduxStore/Store';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * Guard de route — redirige vers /login si l'utilisateur n'est pas authentifié.
 * Mémorise la page demandée dans `state.from` pour rediriger après login.
 *
 * Usage dans App.tsx :
 *   <Route path="/..." element={<PrivateRoute><MaPage /></PrivateRoute>} />
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.AuthSlice);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
